import { AuthContextEnum } from '../../../services/authTokenService';
import * as TntCommonResourceRegistryTypes from '../../../clients/stratus/tntCommonResourceRegistry/types';
import { ISessionService } from '../../../services/session';
import StratusTenantHandler from './StratusTenantHandler';
import { TenantStrategyEnum } from './strategy';
import TenantStrategy from './TenantStrategy';
import * as T from './types';
import { DEFAULT_PAGINATION } from './constants';

type CustomerTenantHandlerProperties = {
  fallback?: string;
};

export default class CustomerTenantHandler
  extends StratusTenantHandler
  implements TenantStrategy
{
  private _strategy = TenantStrategyEnum.stratusCustomer;
  private _options: CustomerTenantHandlerProperties;
  private _assetReference: string;
  private _sessionService: ISessionService;

  constructor({
    stack,
    options,
    authProvider,
    parentAuthProvider,
    assetReference,
    sessionService,
    tenantsDataRepository
  }: T.TenantHandlerStrategyType) {
    super({ stack, authProvider, parentAuthProvider, tenantsDataRepository });
    this._options = options;
    this._assetReference = assetReference;
    this._sessionService = sessionService;
  }

  getAssetReference(): string {
    return this._assetReference;
  }

  getStrategy = (): TenantStrategyEnum => {
    return this._strategy;
  };

  //TODO: why we have a ID as a parameter since the exchange is based on the values present on the repository?
  setTenant = async (
    id: string,
    authContext: AuthContextEnum
  ): Promise<void> => {
    await this._sessionService.exchangeToken(
      id,
      authContext,
      TenantStrategyEnum.stratusCustomer
    );
  };

  /**
   * Gets the organization tenant ID from the global Shell object
   * @returns Promise resolving to the organization tenant ID
   */
  private async _getOrganizationTenantId(): Promise<string> {
    // TODO: Use the Proper service to handle it
    return (window as any).Shell.v1.tenantHandler.getTenantByLevel(1)?.id;
  }

  /**
   * Fetches paginated tenant list data from the backend services
   * @param options - Options for pagination and filtering
   * @returns Promise resolving to paginated tenant visualization data
   */
  public async _getPaginatedTenantListData(
    options: T.GetPaginatedTenantListOptionsType
  ): Promise<T.PaginatedTenantVisualizationType> {
    options.tenantId = await this._getOrganizationTenantId();
    const nodeResponse: TntCommonResourceRegistryTypes.GetNodeResponseType =
      await this._nodeClient.getNodeAdministersCrossUses(
        options as TntCommonResourceRegistryTypes.GetNodeAdministersCrossUsesOptionsType
      );

    const tenants: T.TenantVisualizationType[] = nodeResponse.content.map(
      (content) => {
        return {
          id: content.nodeId,
          name: content.accountName
        };
      }
    );

    return {
      tenants,
      currentPage:
        nodeResponse.pageable.pageNumber || DEFAULT_PAGINATION.CURRENT_PAGE,
      totalPages: nodeResponse.totalPages || DEFAULT_PAGINATION.TOTAL_PAGES
    };
  }

  isRequiredToNavigate = (): boolean => {
    return false;
  };

  getFallback = (): string => {
    return this?._options?.fallback;
  };

  isTenantValid(
    filter: T.TenantHandlerFilterType,
    tenant: T.TenantVisualizationType
  ): boolean {
    console.info(
      `Method isTenantValid is not implemented - tenantId: ${tenant?.id} - filter: ${filter}`
    );
    return true;
  }
}
